export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9814.1e43f541.jpg";